import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const BehavioralSafetyTrendChart = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs text-muted-foreground">
              <span style={{ color: entry?.color }}>{entry?.name}: </span>
              <span className="font-medium">{entry?.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis 
          dataKey="month" 
          stroke="var(--color-muted-foreground)" 
          tick={{ fill: 'var(--color-muted-foreground)' }}
        />
        <YAxis 
          stroke="var(--color-muted-foreground)" 
          tick={{ fill: 'var(--color-muted-foreground)' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ 
            paddingTop: '20px',
            color: 'var(--color-foreground)'
          }}
        />
        <Line 
          type="monotone" 
          dataKey="fatalities" 
          stroke="var(--color-error)" 
          strokeWidth={2}
          name="Fatalities"
          dot={{ fill: 'var(--color-error)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="lostTimeInjury" 
          stroke="var(--color-error)" 
          strokeWidth={2}
          strokeDasharray="5 5"
          name="Lost Time Injury"
          dot={{ fill: 'var(--color-error)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="majorInjury" 
          stroke="var(--color-warning)" 
          strokeWidth={2}
          name="Major Injury"
          dot={{ fill: 'var(--color-warning)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="minorInjury" 
          stroke="var(--color-warning)" 
          strokeWidth={2}
          strokeDasharray="5 5"
          name="Minor Injury"
          dot={{ fill: 'var(--color-warning)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="nearMiss" 
          stroke="var(--color-accent)" 
          strokeWidth={2}
          name="Near Miss"
          dot={{ fill: 'var(--color-accent)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="unsafeActs" 
          stroke="var(--color-primary)" 
          strokeWidth={2}
          name="Unsafe Acts"
          dot={{ fill: 'var(--color-primary)', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="unsafeConditions" 
          stroke="var(--color-primary)" 
          strokeWidth={2}
          strokeDasharray="5 5"
          name="Unsafe Conditions"
          dot={{ fill: 'var(--color-primary)', r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default BehavioralSafetyTrendChart;